import React from "react";
import "./executionModeToggle.css";

export default function ExecutionModeToggle({ mode = "paper", onChange, disabled = false, liveDisabled = false, label = "Execution mode", title }) {
  return <div className="ema-mode-selector execution-mode-toggle" role="group" aria-label={label} title={title}>
    {["paper", "live"].map(value => <button key={value} type="button" aria-pressed={mode === value}
      className={mode === value ? `active ${value}` : ""} disabled={disabled || (value === "live" && liveDisabled)}
      onClick={() => { if (value !== mode) onChange(value); }}>{value.toUpperCase()}</button>)}
  </div>;
}
